import React, { useEffect, useState } from "react";
import { Mic, MicOff, Pause, Play, PhoneOff, Grid3x3, ArrowRightLeft } from "lucide-react";
import { Keypad } from "./Keypad";

const STATUS_COPY = {
  connecting: "Connecting…", ringing: "Ringing…", connected: "Connected",
  ended: "Call ended", failed: "Call failed", no_answer: "No answer", busy: "Line busy",
};

const fmt = (ms) => { const s = Math.floor(ms / 1000); return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`; };

export const ActiveCall = ({ phone }) => {
  const { call, status, muted, held, connectedAt, hangup, toggleMute, toggleHold, sendDigit, transfer } = phone;
  const [now, setNow] = useState(Date.now());
  const [pad, setPad] = useState(false);
  const [xfer, setXfer] = useState(false);
  const [xferTo, setXferTo] = useState("");

  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 1000); return () => clearInterval(t); }, []);
  if (!call) return null;

  const doTransfer = () => {
    const v = xferTo.trim();
    if (!v) return;
    transfer(/^\d{3}$/.test(v) ? { extension: v } : { to_phone: v });
    setXfer(false);
  };

  return (
    <div className="sp-active" data-testid="softphone-active-call">
      <div className="sp-active-name" data-testid="softphone-active-name">{call.target_name || call.target_phone || "Call"}</div>
      <div className={`sp-active-status sp-st-${status}`} data-testid="softphone-call-status">
        {held ? "On hold" : STATUS_COPY[status] || status}
        {status === "connected" && connectedAt && <span className="sp-timer" data-testid="softphone-call-timer"> · {fmt(now - connectedAt)}</span>}
      </div>
      <div className="sp-controls">
        <button className={`sp-ctl ${muted ? "on" : ""}`} onClick={toggleMute} data-testid="softphone-mute-btn">{muted ? <MicOff size={18} /> : <Mic size={18} />}<span>{muted ? "Unmute" : "Mute"}</span></button>
        <button className={`sp-ctl ${held ? "on" : ""}`} onClick={toggleHold} data-testid="softphone-hold-btn">{held ? <Play size={18} /> : <Pause size={18} />}<span>{held ? "Resume" : "Hold"}</span></button>
        <button className={`sp-ctl ${pad ? "on" : ""}`} onClick={() => setPad((p) => !p)} data-testid="softphone-keypad-toggle"><Grid3x3 size={18} /><span>Keypad</span></button>
        <button className={`sp-ctl ${xfer ? "on" : ""}`} onClick={() => setXfer((x) => !x)} data-testid="softphone-transfer-toggle"><ArrowRightLeft size={18} /><span>Transfer</span></button>
      </div>
      {pad && <Keypad onKey={sendDigit} testPrefix="softphone-dtmf" />}
      {xfer && (
        <div className="sp-row">
          <input className="sp-input" value={xferTo} onChange={(e) => setXferTo(e.target.value)} placeholder="extension or number" data-testid="softphone-transfer-input" />
          <button className="sp-btn" onClick={doTransfer} data-testid="softphone-transfer-submit">Send</button>
        </div>
      )}
      <button className="sp-btn-round sp-red sp-hang" onClick={hangup} data-testid="softphone-hangup-btn" title="Hang up"><PhoneOff size={20} /></button>
    </div>
  );
};
